import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'; 

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app-proctor.component';
import { LoadingdivComponent } from './loadingdiv/loadingdiv.component';
import { WebcamaccessnotificationdivComponent } from './webcamaccessnotificationdiv/webcamaccessnotificationdiv.component';
import { ExamiframeComponent } from './examiframe/examiframe.component';
import { ProcteevideomodalComponent } from './procteevideomodal/procteevideomodal.component';
import { ChatmodalComponent } from './chatmodal/chatmodal.component';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { ToastrModule } from 'ngx-toastr';
import { SubdomainInterceptorInterceptor } from './interceptors/subdomain-interceptor.interceptor';

@NgModule({
  declarations: [
    AppComponent,
    LoadingdivComponent,
    WebcamaccessnotificationdivComponent,
    ExamiframeComponent,
    ProcteevideomodalComponent,
    ChatmodalComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    HttpClientModule,
    ToastrModule.forRoot()
  ],
  providers: [{
    provide: HTTP_INTERCEPTORS,
    useClass: SubdomainInterceptorInterceptor,
    multi: true
  }],
  bootstrap: [AppComponent]
})
export class AppModule { }
